import PlatformTestScenarios from './PlatformTestScenarios'

// CQ9 EGAME / FISH / TABLE 以下的兩個測項不帶玩家餘額作為 betAmount，SLOT 全部測項用 this.formData.betAmount
// Multi Bets - Place 2 bets > Settle Win (multiBets_bet1_bet2_settleWin)
// Place 3 bets in 3 rounds > CancelBet (bet1_bet2_bet3_cancelBet123)

/* eslint-disable camelcase, no-await-in-loop, prefer-destructuring */
export default class CQ9TestScenarios extends PlatformTestScenarios {
  getBetAmount() {
    const { platform } = this.formData
    let { betAmount } = this.formData
    if (platform !== 'CQ9SLOT' && platform !== 'MT') betAmount = this.requests.tests.lastBalance[0]
    return betAmount
  }

  async bet_settleWin() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet({
          data: { betAmount: this.getBetAmount() },
        })
        await this.requests.settleWin()
        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }

  async bet_settleLose() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet({
          data: { betAmount: this.getBetAmount() },
        })
        await this.requests.settleLose()
        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }

  async bet_settleWin5Times() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet({
          data: { betAmount: this.getBetAmount() },
        })

        const summaryBetReqId = this.requests.actions.summaryReqId

        for (let timesLoop = 0; timesLoop < 5; timesLoop += 1) {
          if (this.requests.actions.summaryReqId) this.requests.actions.summaryReqId = summaryBetReqId
          await this.requests.settleWin({ timesLoop })
        }

        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }

  async bet_asyncSettleWin5Times() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet({
          data: { betAmount: this.getBetAmount() },
        })

        if (this.requests.actions.summaryReqId) {
          this.requests.actions.summaryReqId += 1
          this.requests.actions.isAsync = true
        }

        await Promise.all(Array.from({ length: 5 }).map(async (_, timesLoop) => {
          await this.requests.settleWin({
            timesLoop,
            options: { isAsync: true },
          })
          return true
        }))

        await this.requests.getBalance({ action: 'asyncSettle' })
        delete this.requests.actions.isAsync
      },
    )
  }

  async multiBets_bet1_bet2_settleWin() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()

        const BET_LENGTH = 2
        const betIndexes = []
        for (let betIndex = 0; betIndex < BET_LENGTH; betIndex += 1) {
          await this.requests.bet({
            betIndexes: [betIndex],
          })
          betIndexes.push(betIndex)
        }

        await this.requests.settleWin({ betIndexes })
        await this.requests.getBalance({ action: 'settle' })
      },
    )
  }

  async bet_cancelBet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet({
          data: { betAmount: this.getBetAmount() },
        })
        if (this.requests.actions.summaryReqId) this.requests.actions.summaryRefId = this.requests.actions.summaryReqId
        await this.requests.cancelBet()
      },
    )
  }

  async bet_cancelBet5Times() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet({
          data: { betAmount: this.getBetAmount() },
        })

        const summaryBetReqId = this.requests.actions.summaryReqId
        if (this.requests.actions.summaryReqId) this.requests.actions.summaryRefId = this.requests.actions.summaryReqId

        for (let timesLoop = 0; timesLoop < 5; timesLoop += 1) {
          if (this.requests.actions.summaryReqId) this.requests.actions.summaryReqId = summaryBetReqId
          await this.requests.cancelBet({ timesLoop })
        }
      },
    )
  }

  async cancelBetOnly() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()

        if (this.requests.actions.summaryReqId) {
          this.requests.actions.summaryReqId += 1
          this.requests.actions.summaryRefId = this.requests.actions.summaryReqId
        }

        await this.requests.cancelBet({ options: { beforeBet: true } })
      },
    )
  }

  async cancelBet_bet() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()

        if (this.requests.actions.summaryReqId) {
          this.requests.actions.summaryReqId += 1
          this.requests.actions.summaryRefId = this.requests.actions.summaryReqId
        }

        await this.requests.cancelBet({ options: { beforeBet: true } })
        if (this.requests.actions.summaryReqId) this.requests.actions.summaryReqId -= 2

        await this.requests.bet({
          data: { betAmount: this.getBetAmount() },
          options: { afterCancelBet: true },
        })
        if (this.requests.actions.summaryReqId) this.requests.actions.summaryReqId += 1

        await this.requests.getBalance({ action: 'betAfterCancelBet' })
      },
    )
  }

  async bet_settleWin_resettleLose_resettleWin() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet({
          data: { betAmount: this.getBetAmount() },
        })
        await this.requests.settleWin()
        await this.requests.getBalance({ action: 'settle' })

        await this.requests.resettle({ options: { resettleResult: 'lose' } })
        await this.requests.getBalance({ action: 'resettle' })

        await this.requests.resettle({ options: { resettleResult: 'win' } })
        await this.requests.getBalance({ action: 'resettle' })
      },
    )
  }

  async bet_settleLose_resettleWin5Times() {
    await this.setTestScenario(
      async () => {
        await this.requests.getBalance()
        await this.requests.bet({
          data: { betAmount: this.getBetAmount() },
        })
        await this.requests.settleLose()
        await this.requests.getBalance({ action: 'settle' })

        for (let timesLoop = 0; timesLoop < 5; timesLoop += 1) {
          await this.requests.resettle({
            options: { resettleResult: 'win' },
            timesLoop,
          })
        }

        await this.requests.getBalance({ action: 'resettle' })
      },
    )
  }
}
